import { render, staticRenderFns } from "./RegistraPezzi.vue?vue&type=template&id=0ed49a95&scoped=true&"
import script from "./RegistraPezzi.vue?vue&type=script&lang=js&"
export * from "./RegistraPezzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed49a95",
  null
  
)

export default component.exports